// TikTok Pixel helper utilities
// Provides type-safe wrappers for ttq tracking calls

declare global {
  interface Window {
    ttq?: {
      identify: (params: Record<string, string>) => void;
      track: (event: string, params?: Record<string, unknown>) => void;
      page: (...args: unknown[]) => void;
    };
  }
}

// Remove test_event_code for production traffic
const TEST_EVENT_CODE: string | null = null;

interface ContentItem {
  content_id: string;
  content_type: 'product' | 'product_group';
  content_name: string;
  content_category?: string;
}

interface TrackParams {
  contents: ContentItem[];
  value?: number;
  currency?: string;
}

function track(event: string, params: TrackParams) {
  if (typeof window !== 'undefined' && window.ttq) {
    const payload: Record<string, unknown> = { ...params };
    if (TEST_EVENT_CODE) {
      payload.test_event_code = TEST_EVENT_CODE;
    }
    window.ttq.track(event, payload);
  }
}

export function trackViewContent(
  contentId: string,
  contentName: string,
  contentCategory: string,
  value?: number
) {
  track('ViewContent', {
    contents: [
      {
        content_id: contentId,
        content_type: 'product',
        content_name: contentName,
        content_category: contentCategory,
      },
    ],
    value: value,
    currency: 'EGP',
  });
}

export function trackClickButton(
  contentId: string,
  contentName: string
) {
  track('ClickButton', {
    contents: [
      {
        content_id: contentId,
        content_type: 'product',
        content_name: contentName,
      },
    ],
  });
}

export function trackLead(
  contentId: string,
  contentName: string,
  contentCategory: string,
  value?: number
) {
  track('Lead', {
    contents: [
      {
        content_id: contentId,
        content_type: 'product',
        content_name: contentName,
        content_category: contentCategory,
      },
    ],
    value: value,
    currency: 'EGP',
  });
}

export function trackCompleteBooking(
  contentId: string,
  contentName: string,
  contentCategory: string
) {
  track('CompleteRegistration', {
    contents: [
      {
        content_id: contentId,
        content_type: 'product',
        content_name: contentName,
        content_category: contentCategory,
      },
    ],
  });
}
